import { useState } from 'react';
import { Button } from '@flixbus/honeycomb-react';
import { VoucherFormSection } from '../../Section';
import { BlackoutFrom } from '../BlackoutFrom';
import { BlackoutTo } from '../BlackoutTo';
import { Icon, IconOffer } from '@flixbus/honeycomb-icons-react';
import styles from './voucher-form-blackout-period.module.scss';

const BlackoutPeriod = ({ index }: { index: number }) => {
  return (
    <>
      <BlackoutFrom index={index} />
      <BlackoutTo index={index} />
    </>
  );
};

const VoucherFormBlackoutPeriod = () => {
  const [periodCount, setPeriodCount] = useState(3);

  const handleAddPeriod = () => {
    setPeriodCount(prev => prev + 1);
  };

  return (
    <VoucherFormSection
      title='Blackout periods'
      subtitle="When the trip can't happen"
      inputs={
        <>
          {Array.from({ length: periodCount }, (_, index) => (
            <BlackoutPeriod key={index} index={index} />
          ))}
          <Button
            size='md'
            onClick={handleAddPeriod}
            extraClasses={styles.addButton}
            appearance='link'
          >
            <Icon InlineIcon={IconOffer} />
            Add blackout period
          </Button>
        </>
      }
    />
  );
};

export default VoucherFormBlackoutPeriod;
